<template>
    <section class="infographic modules-ranking light blue">
        <circles-layout></circles-layout>
        <div class="blocks-wrapper">
            <div class="block" ref="block">
                <h3>Populaire modules</h3>
                <div class="solid-circles-wrapper">
                    <div>
                        <div class="solid-circle">
                            <p>2</p>
                        </div>
                        <p>Eduarte*: aan- en afwezigheid registeren en bewerken</p>
                    </div>
                    <div>
                        <div class="solid-circle">
                            <p>1</p>
                        </div>
                        <p>Eduarte*: introductie en kennismaking</p>
                    </div>
                    <div>
                        <div class="solid-circle">
                            <p>3</p>
                        </div>
                        <p>Eduarte*: maken en onderhouden Studiewijzers</p>
                    </div>
                </div>

                <p class="small">*Studenten&shy;administratie&shy;systeem</p>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';

    import { gsap } from '@/vendor';

    export default {
        name: 'InfoModulesRanking',

        meta: {
            title: 'InfoModulesRanking',
            color: '#36B1CA'
        },

        components: {
            'circles-layout': Circles
        },

        data()
        {
            return {
                theme: {
                    text: '#000000',
                    stroke: '#36B1CA',
                    track: '#eaf7fa'
                }
            };
        },
        mounted()
        {
            this.tl = gsap.timeline({ paused: true });

            this.tl.from( this, { aantal: 0, duration: 1, roundProps: 'aantal' }, 0.3 );
            this.tl.from( this, { essentials: 0, duration: 1, roundProps: 'essentials' }, 0.4 );
            this.tl.from( this, { eLearning: 0, duration: 1, roundProps: 'eLearning' }, 0.5 );
            this.tl.from( this, { webinars: 0, duration: 1, roundProps: 'webinars' }, 0.6 );
            this.tl.from( this, { podcast: 0, duration: 1, roundProps: 'podcast' }, 0.7 );
        },

        methods: {
            focus()
            {
                this.tl.play();
            },
            blur()
            {
                this.tl.reverse();
            }
        }
    };
</script>
